"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import MainLayout from "@/app_views/MainLayout.vue";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import ElPhoneVerifyCodeInput from "../framework/components/form/ElPhoneVerifyCodeInput.vue";
import Validator from "../framework/components/form/validator";
import API from "@ym-framework/api-utils";
import { Component, Vue, Ref } from "vue-property-decorator";
let Register3 = class extends Vue {
  constructor() {
    super(...arguments);
    this.status = "ready";
    this.rules = {
      phone: [
        {
          required: true,
          message: "\u624B\u673A\u53F7\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u786E\u8BA4\u540E\u518D\u6B21\u8F93\u5165",
          trigger: "blur"
        },
        { validator: Validator.phone, trigger: "blur" }
      ],
      password: [
        {
          required: true,
          message: "\u5BC6\u7801\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u786E\u8BA4\u540E\u518D\u6B21\u8F93\u5165\u3002",
          trigger: "blur"
        },
        {
          min: 6,
          max: 24,
          message: "\u5F53\u524D\u5BC6\u7801\u957F\u5EA6\u4E0D\u6B63\u786E\uFF0C\u5E94\u4E3A6\u523024\u4F4D",
          trigger: "blur"
        },
        { validator: Validator.password, trigger: "blur" }
      ],
      verify_code: [
        {
          required: true,
          message: "\u6821\u9A8C\u7801\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u786E\u8BA4\u540E\u518D\u6B21\u8F93\u5165\u3002",
          trigger: "blur"
        }
      ]
    };
    this.formData = {
      query_param: null,
      phone: "",
      password: "",
      verify_code: "",
      invite_code: null,
      open_id: null
    };
    this.weixin = {
      code: null,
      state: -1,
      open_id: null,
      union_id: null,
      refresh_token: null,
      access_token: null
    };
    this.isWeiXin = false;
  }
  mounted() {
    return __async(this, null, function* () {
      this.isInWechatMP();
    });
  }
  isInWechatMP() {
    const array = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    const userAgent = navigator.userAgent;
    let flag = false;
    for (let i = 0; i < array.length; i++) {
      if (userAgent.indexOf(array[i]) > 0) {
        flag = true;
        break;
      }
    }
    if (navigator.userAgent.match(/miniprogram/i) || //@ts-ignore
    window.__wxjs !== void 0 && //@ts-ignore
    window.__wxjs.environment === "miniprogram" || window.navigator.userAgent.match(/Mobile/i) || flag) {
      this.isWeiXin = true;
      document.getElementsByTagName("body")[0].style.minWidth = "0";
      document.getElementsByTagName("html")[0].style.minWidth = "0";
      document.getElementById("app").style.minWidth = "0";
    } else {
      this.isWeiXin = false;
    }
  }
  sendPhoneCode(lock) {
    return __async(this, null, function* () {
      try {
        let validPhone = true;
        yield this._selfForm.validateField("phone", (errorMessage) => {
          validPhone = errorMessage === "";
        });
        if (validPhone) {
          const response = yield API.post(
            "api://base.app/api/v1/wechat/drainage/sendMessage",
            {
              code_type: 0,
              phone: this.formData.phone
            }
          );
          this.$message({
            message: "\u9A8C\u8BC1\u7801\u77ED\u606F\u5DF2\u7ECF\u53D1\u9001\u81F3:" + this.formData.phone + "\u8BF7\u6CE8\u610F\u67E5\u6536",
            offset: 60
          });
          lock(90);
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        this.status = "submit";
        var domine = window.location.href.split("?")[1].split("&");
        let obj = {};
        domine.forEach((item, i) => {
          let _item = item.split("=");
          obj[_item[0]] = _item[1];
        });
        yield API.post(
          `api://base.app/api/v1/wechat/drainage/register/${obj.code}`,
          this.formData
        );
        this.$router.push({
          name: "register_success",
          params: {
            message: "\u4E13\u5C5E\u4F18\u60E0\u5DF2\u53D1\u9001\u60A8\u7684\u8D26\u6237\uFF0C\u8BF7\u5728\u7535\u8111\u7AEF\u4E0B\u8F7D\u8DE8\u5883\u536B\u58EB\u5BA2\u6237\u7AEF\uFF0C\u5FAE\u4FE1\u626B\u7801\u767B\u5F55\u8DE8\u5883\u536B\u58EB\uFF0C\u7BA1\u7406\u5E97\u94FA"
          }
        });
      } catch (error) {
        this.status = "ready";
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("selfForm")
], Register3.prototype, "_selfForm", 2);
Register3 = __decorateClass([
  Component({
    components: {
      MainLayout,
      PasswordInput,
      ElPhoneVerifyCodeInput
    }
  })
], Register3);
export {
  Register3 as default
};
